// extracted by mini-css-extract-plugin
export default {"main":"StarAuthorCard_main__sZP7Y","authorImage":"StarAuthorCard_authorImage__rLQhx","authorName":"StarAuthorCard_authorName__PJ5HA","triangle":"StarAuthorCard_triangle__zziLb"};